<div class="card notification-list dp-mt-s" *ngIf="notifications.length > 0; else noNotifications">
    <ion-toolbar class="notifications-toolbar" color="none">
        <ion-title>
            {{ 'notifications.title' | translate }}
        </ion-title>
        <ion-buttons slot="end" *ngIf="!loading">
            <ion-button
                fill="clear"
                color="primary"
                class="round"
                size="small"
                dpTooltip
                [tooltipContent]="'notifications.mark-all-as-done' | translate"
                (click)="onDeleteNotification(notifications, $event)"
            >
                <fa-icon icon="check-double"></fa-icon>
            </ion-button>
            <ion-button
                fill="clear"
                class="round"
                color="primary"
                size="small"
                dpTooltip
                [tooltipContent]="'notifications.reload' | translate"
                (click)="manualRefresh()"
            >
                <fa-icon icon="sync-alt"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
    <p-table class="notifications-table" [value]="notifications" stripedRows [scrollable]="true">
        <ng-template #body let-notification>
            <tr>
                <td [ngClass]="{ 'ion-text-center': utils.isPhone, 'td-mobile': utils.isPhone }">
                    @if (utils.isPhone) {
                        <ng-container
                            [ngTemplateOutlet]="notificationType"
                            [ngTemplateOutletContext]="{ notifyData: notification }"
                        ></ng-container>
                    }
                    <span class="notification-date">{{ notification.notificationDate | date: 'dd.MM.yyyy' }}</span>
                    @if (utils.isPhone) {
                        <span class="notification-name">{{ notification.name }}</span>
                    }
                    <fa-icon
                        icon="users"
                        class="dp-ml-s"
                        dpTooltip
                        tooltipTrigger="click mouseenter focus"
                        [tooltipContent]="'notifications.company-wide-info' | translate"
                        *ngIf="notification.companyWideNotification"
                    ></fa-icon>
                </td>
                @if (!utils.isPhone) {
                    <td class="ion-text-center">
                        <ng-container
                            [ngTemplateOutlet]="notificationType"
                            [ngTemplateOutletContext]="{ notifyData: notification }"
                        ></ng-container>
                        <br />
                        <span class="notification-name">{{ notification.name }}</span>
                    </td>
                }
                <td class="ion-text-center project-info" [ngClass]="{ 'td-mobile': utils.isPhone }">
                    {{ notification.relatedProjectName }}<br />
                    {{ notification.relatedJobNumber }} - {{ notification.relatedJobName }}
                    <!--<ng-container *ngIf="notification.relatedJobExtensionName != null">
                                    ({{ notification.relatedJobExtensionName }})
                                </ng-container>-->
                </td>
                <td class="notification-actions ion-text-end">
                    <ion-button
                        size="small"
                        class="round"
                        fill="clear"
                        dpTooltip
                        [tooltipContent]="'notifications.view' | translate"
                        *ngIf="notification.description != null && notification.description != ''"
                        (click)="onViewNotificationModal(notification)"
                    >
                        <fa-icon icon="comment-question"></fa-icon>
                    </ion-button>
                    <ion-button
                        size="small"
                        class="round"
                        fill="clear"
                        dpTooltip
                        [tooltipContent]="'shared.open' | translate"
                        (click)="onClickNotificationItem(notification)"
                    >
                        <fa-icon icon="arrow-right"></fa-icon>
                    </ion-button>
                    <ion-button
                        size="small"
                        class="round"
                        fill="clear"
                        dpTooltip
                        [tooltipContent]="'notifications.mark-as-done' | translate"
                        (click)="onDeleteNotification(notification, $event)"
                    >
                        <fa-icon icon="check-circle"></fa-icon>
                    </ion-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <ng-template #notificationType let-notification="notifyData">
        <span class="notification-type">
            @switch (notification.type) {
                @case ('job-created') {
                    {{ 'notifications.types.new-job' | translate }}
                }
                @case ('article-added') {
                    {{ 'notifications.types.new-article' | translate }}
                }
                @case ('article-reminder') {
                    {{ 'notifications.types.article-reminder' | translate }}
                }
                @case ('project-reminder') {
                    {{ 'notifications.types.project-reminder' | translate }}
                }
                @case ('public-code-submission') {
                    {{ 'notifications.types.public-code' | translate }}
                }
            }
        </span>
    </ng-template>
    <!-- NEW EVENT DIALOG -->
    <ion-modal [isOpen]="notificationDetailsModalVisible" (ionModalDidDismiss)="notificationDetailsModalVisible = false">
        <ng-template>
            <ion-header>
                <ion-toolbar color="none">
                    <ion-title>
                        {{ currentModalNotification.name }} | {{ currentModalNotification.createdByDisplayName }} |
                        {{ currentModalNotification.createdAt | date: 'dd.MM.yyyy' }}</ion-title
                    >
                    <ion-buttons slot="end">
                        <ion-button fill="clear" shape="round" color="dark" (click)="notificationDetailsModalVisible = false">
                            <fa-icon slot="icon-only" icon="times"></fa-icon>
                        </ion-button>
                    </ion-buttons>
                </ion-toolbar>
            </ion-header>
            <ion-content class="ion-padding notification-description-in-modal">
                {{ currentModalNotification.description }}
                <div class="dp-mt-s" *ngIf="currentModalNotification.relatedJobExtensionName != null">
                    <app-info-bar>{{
                        'notifications.je-added-info'
                            | translate: { relatedJobExtensionName: currentModalNotification.relatedJobExtensionName }
                    }}</app-info-bar>
                </div>
            </ion-content>
        </ng-template>
    </ion-modal>
</div>

<ng-template #noNotifications>
    <div class="dp-mt-s">
        @if (!loading) {
            <div class="notifications-none-wrap">
                <div class="notifications-icon">
                    <img src="/assets/icon/notifications-none.svg" alt="No notifications" />
                </div>
                <div class="notifications-info">
                    <strong>
                        {{ 'notifications.no-entries' | translate }}
                    </strong>
                </div>
            </div>
        } @else {
            <app-loading-indicator [dpIsLoading]="loading">{{ 'notifications.loading' | translate }}</app-loading-indicator>
        }
    </div>
</ng-template>
